"use client";

import type { ReviewItem } from "@/lib/api/projection-types";
import type { ContentQueueItem } from "@/lib/api";
import LibraryCard from "./LibraryCard";
import LibraryListRow from "./LibraryListRow";
import type { LibraryViewMode } from "@/lib/libraryFormatters";

interface Props {
  items: ReviewItem[];
  resourceDetails: Record<string, ContentQueueItem>;
  recommended: boolean;
  view: LibraryViewMode;
  selectedIds: Set<string>;
  selecting: boolean;
  busyId: string | null;
  onToggleSelect: (id: string) => void;
  onOpenDetail: (id: string) => void;
  onEdit: (id: string) => void;
  onLinkGoal: (id: string) => void;
  onAddToTodo: (item: ReviewItem) => void;
  onAddToSchedule: (item: ReviewItem) => void;
  onDismiss: (item: ReviewItem) => void;
}

export default function LibraryItemList({
  items,
  resourceDetails,
  recommended,
  view,
  selectedIds,
  selecting,
  busyId,
  onToggleSelect,
  onOpenDetail,
  onEdit,
  onLinkGoal,
  onAddToTodo,
  onAddToSchedule,
  onDismiss,
}: Props) {
  if (view === "grid") {
    return (
      <div
        className="grid gap-3"
        style={{ gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))" }}
      >
        {items.map((item) => (
          <LibraryCard
            key={item.id}
            item={item}
            detail={resourceDetails[item.id]}
            recommended={recommended}
            selected={selectedIds.has(item.id)}
            selecting={selecting}
            busy={busyId === item.id}
            onToggleSelect={onToggleSelect}
            onOpenDetail={onOpenDetail}
            onEdit={onEdit}
            onLinkGoal={onLinkGoal}
            onAddToTodo={onAddToTodo}
            onAddToSchedule={onAddToSchedule}
            onDismiss={onDismiss}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      {items.map((item) => (
        <LibraryListRow
          key={item.id}
          item={item}
          detail={resourceDetails[item.id]}
          recommended={recommended}
          selected={selectedIds.has(item.id)}
          selecting={selecting}
          busy={busyId === item.id}
          onToggleSelect={onToggleSelect}
          onOpenDetail={onOpenDetail}
          onAddToTodo={onAddToTodo}
          onAddToSchedule={onAddToSchedule}
        />
      ))}
    </div>
  );
}
